import { decorate, inject, injectable } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { NetworkError, UserError } from 'errors';

interface SignInData {
  username: string;
  [key: string]: unknown;
}

interface ApiService {
  get(route: string): Promise<unknown>;
  post(route: string, data: SignInData): Promise<unknown>;
}

class AuthService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  async signIn(data: SignInData): Promise<unknown> {
    const formattedData = { ...data, username: data.username.trim() };

    try {
      return await this.apiService.post('/login', formattedData);
    } catch (e) {
      if (e instanceof NetworkError) {
        const userError = new UserError();
        userError.message = e.message;
        throw userError;
      }

      throw e;
    }
  }

  async signOut(): Promise<unknown> {
    return this.apiService.get('/logout');
  }
}

(decorate as (
  decorator: ClassDecorator,
  target: unknown,
) => void)(injectable() as ClassDecorator, AuthService);
(
  decorate as (
    decorator: ParameterDecorator,
    target: unknown,
    parameterIndex: number,
  ) => void
)(inject(SERVICE_IDENTIFIER.ApiService) as ParameterDecorator, AuthService, 0);

export default AuthService;
